import React from 'react';
import { connect } from 'react-redux';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import Select from 'react-select';

import { getMaterijalGroups, getMaterialGroup, setRowInReducer, setInitialState } from '../../../actions/resources/MaterialActions';
import i18n from '../../../i18n/i18n';
import immutable from 'seamless-immutable';
import AddMaterialGroup from './AddMaterialGroup';
import checkboxHOC from "react-table/lib/hoc/selectTable";
const CheckboxTable = checkboxHOC(ReactTable);
export class ViewMaterialGroup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            add: this.props.add,
            edit: this.props.edit,
            showFilters: this.props.showFilters,
            selection: [],
            selectAll: false
        };
    }

    componentDidMount() {
        if (this.props.materialGroupDropdown.length === 0) {
            this.props.getMaterialGroup();
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.deleted === true) {
            const wrapped = this.checkboxTable.getWrappedInstance();
            this.props.getMaterijalGroups(wrapped.state);
            this.setState({
                selection: [],
                selectAll: false,
            })
            this.props.setInitialState('deleted');

        }
        if (nextProps.materialGroupPostingSuccess === true) {
            this.setState({
                selection: [],
                name: '',
                selectAll: false
            })
            this.props.handleClose();
            const wrapped = this.checkboxTable.getWrappedInstance();
            this.props.getMaterijalGroups(wrapped.state);
            this.props.setInitialState('materialGroupPostingSuccess');
        }
        this.setState({
            add: nextProps.add,
            showFilters: nextProps.showFilters,
            materialGroupDropdown: immutable.asMutable(nextProps.materialGroupDropdown.map((item) => { return { label: item.naziv, value: item.id } }), { deep: true }),
            groupFetching: nextProps.groupFetching,
            groupFetchingFailed: nextProps.groupFetchingFailed,
        })
        if (nextProps.add == true && nextProps.edit == false) {
            this.props.setInitialState('materialGroupObj');
            this.setState({
                selection: [],
                name: '',
                selectAll: false
            })
        }
    }

    toggleSelection = (key, shift, row) => {
        let selection = [...this.state.selection];
        const keyIndex = selection.indexOf(key);
        if (keyIndex >= 0) {
            selection = [
                ...selection.slice(0, keyIndex),
                ...selection.slice(keyIndex + 1)
            ];
        } else {
            selection.push(key);
        }
        this.setState({ selection }, function () {
            if (selection.length == 1) {
                let row1 = this.props.material_group.filter((mat) => {
                    return mat.id == selection;
                })
                this.props.setRowInReducer(row1[0], 'materialGroupObj');
            }
        });
        this.props.setSelection(selection, 'material_group');
    };

    toggleAll = () => {
        const selectAll = this.state.selectAll ? false : true;
        const selection = [];
        if (selectAll) {
            const wrappedInstance = this.checkboxTable.getWrappedInstance();
            const currentRecords = wrappedInstance.getResolvedState().sortedData;
            currentRecords.forEach(item => {
                selection.push(item._original.id);
            });
        }
        this.setState({ selectAll, selection });
        this.props.setSelection(selection, 'material_group');

    };

    isSelected = key => {
        return this.state.selection.includes(key);
    };

    render() {
        let content;
        const { toggleSelection, toggleAll, isSelected } = this;
        const { selectAll } = this.state;
        const checkboxProps = {
            selectAll,
            isSelected,
            toggleSelection,
            toggleAll,
            selectType: "checkbox",
            getTrProps: (state, rowInfo, instance) => {
                if (rowInfo) {
                    const selected = this.isSelected(rowInfo.original.id);
                    return {
                        style: {
                            backgroundColor: selected ? "#ACDAF1" : "inherit"
                        }
                    };
                }
                return {};
            }
        };
        content =
            <div className="page">
                <CheckboxTable data={this.props.material_group}
                    ref={r => (this.checkboxTable = r)}
                    keyField={'id'}
                    columns={this.columns}
                    pageSizeOptions={[10, 25, 50, 100]}
                    defaultPageSize={25}
                    filterable={this.state.showFilters}
                    showPaginationTop
                    showPaginationBottom={false}
                    pages={this.props.materialGroupPages}
                    loading={this.props.materialGroupsFetching}
                    manual
                    onFetchData={(state, instance) => this.props.getMaterijalGroups(state, instance)}
                    className="-striped -highlight"
                    previousText={i18n.t('Previous')}
                    nextText={i18n.t('Next')}
                    loadingText={i18n.t('Loading...')}
                    noDataText={i18n.t('No rows found')}
                    pageText={i18n.t('Page')}
                    ofText={i18n.t('of')}
                    rowsText={i18n.t('rows')}
                    {...checkboxProps}
                    PreviousComponent={(props) => (
                        <button {...props} className='-btn' style={{
                            backgroundColor: '#4FA2CD',
                            color: '#FFFFFF',
                        }}>{props.children}</button>
                    )}
                    NextComponent={(props) => (
                        <button {...props} className='-btn' style={{
                            backgroundColor: '#4FA2CD',
                            color: '#FFFFFF'
                        }}>{props.children}</button>
                    )}
                />
                {this.state.add && <AddMaterialGroup add={this.state.add} edit={this.props.edit}
                    handleClose={this.props.handleClose} />}
            </div>


        return (
            <div>
                {content}
            </div >
        )
    }

    columns = [
        {
            Header: i18n.t('Title'),
            accessor: 'naziv',
            Filter: ({ filter, onChange }) =>
                <Select
                    isMulti
                    name="naziv"
                    onChange={value => {
                        onChange(value)
                    }}
                    closeMenuOnSelect={false}
                    options={this.state.materialGroupDropdown}
                    className="multi-select-in-filter"
                    classNamePrefix="select"
                    placeholder={i18n.t('Select')}
                />
        },
        {
            Header: i18n.t('Icon name'),
            accessor: 'ime_ikonice',

        },
        {
            Header: i18n.t('Priority'),
            accessor: 'prioritet',
        },
        {
            Header: i18n.t('Color'),
            accessor: 'boja',
        },
    ];
};

function mapStateToProps(state) {
    return {
        materialGroupDropdown: state.materialReducer.materialGroupDropdown,
        groupFetching: state.materialReducer.groupFetching,
        groupFetchingFailed: state.materialReducer.groupFetchingFailed,
        material_group: state.materialReducer.material_group,
        materialGroupsFetching: state.materialReducer.materialGroupsFetching,
        materialGroupsFetchingFailed: state.materialReducer.materialGroupsFetchingFailed,
        materialGroupPages: state.materialReducer.materialGroupPages,
        deleted: state.materialReducer.deleted,
        materialGroupPostingSuccess: state.materialReducer.materialGroupPostingSuccess,

    }
}

function mapDispatchToProps(dispatch) {
    return {
        getMaterialGroup: () => dispatch(getMaterialGroup()),
        setInitialState: (component) => dispatch(setInitialState(component)),
        setRowInReducer: (rowInfo, name) => dispatch(setRowInReducer(rowInfo, name)),
        getMaterijalGroups: (state, instance) => dispatch(getMaterijalGroups(state, instance))
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ViewMaterialGroup)